module.exports = __webpack_public_path__ + "images/img_IP_6-061ffce7eb.png";